export default __webpack_public_path__ + "static/media/netlify.709d3fee.svg";